<template>
  <v-card class="pa-5"   :style="{ border: '1px solid var(--primary-boarder-color)' }">
    <v-row class="mb-2 pa-5 pb-1 d-flex justify-space-between align-center">
      <span class="text-h6 font-weight-bold">Recent Activity</span>
    </v-row>
    <v-divider class="border-opacity-25"></v-divider>
    <v-list class="custom-list-style" v-if="activityLogs">
      <v-list-item-group v-for="(activity, index) in reversedActivityLogs" :key="index">
        <v-list-item :disabled="true">
          <v-list-item-icon>
            <v-icon :color="getIconColor(activity.action.toLowerCase())">{{ getIcon(activity.action.toLowerCase()) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-light text-black">
                {{ activity.comment }}
            </v-list-item-title>
            <v-list class="d-flex align-center ma-0 pa-0 pt-1">
              <v-avatar color="gray" size="32" class="mr-3">
                <img v-if="activity.created_by.profile_image" :src="activity.created_by.profile_image" />
                <img v-else :src="defaultImage" />
              </v-avatar>
              <v-list class="pa-0 ma-0">
                <v-list-item-subtitle class="comment-text font-weight-light">{{ activity.created_by.name }}</v-list-item-subtitle>
                <v-list-item-subtitle class="comment-text font-weight-light">{{ formatDateString(activity.created_at) }}</v-list-item-subtitle>
              </v-list>
            </v-list>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<style scoped>
.text-black {
  color: #000000;
}
.custom-list-style {
  height: 500px;
  overflow-y: auto;
  position: relative;
}

.comment-text {
  color: #707070;
}
</style>

  
<script>
export default {

  data: () => ({
      defaultImage: require("@/assets/img/avatar.svg"),
      recentActivities: [
      ],
  }),
  props: {
    activityLogs: Array
  },
  computed: {
    reversedActivityLogs() {
      return [...this.activityLogs].reverse();
    },
  },
  methods: {
    getIcon(type) {
      const iconMap = {
         email: 'mdi-email',
         task: 'mdi-format-list-checkbox',
         comment: 'mdi-comment',
         meeting: 'mdi-calendar-clock',
         upload: 'mdi-file',
         status: 'mdi-information-outline',
         approval: 'mdi-thumb-up',
         update: 'mdi-cogs',
         achievement: 'mdi-trophy',
         create: 'mdi-plus',
         delete: 'mdi-delete', 
      };
      return iconMap[type] || 'mdi-help-circle';
    },
    getIconColor(type) {
      const colorMap = {
          email: 'blue',
          task: 'orange',
          comment: 'green',
          meeting: 'purple',
          upload: 'indigo',
          status: 'teal',
          approval: 'amber',
          announcement: 'cyan',
          update: 'brown',
          achievement: 'pink',
          create: 'green',
          delete: 'orange', 
      };
      return colorMap[type] || 'grey';
    },
    formatDate(timestamp) {
      const now = new Date();
      const diffInMillis = now - new Date(timestamp);
      const diffInSeconds = Math.floor(diffInMillis / 1000);
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      const diffInHours = Math.floor(diffInMinutes / 60);
      const diffInDays = Math.floor(diffInHours / 24);
      const diffInWeeks = Math.floor(diffInDays / 7);
      const diffInMonths = Math.floor(diffInDays / 30);
      const diffInYears = Math.floor(diffInDays / 365);
    
      if (diffInYears > 0) {
        return `${diffInYears} ${diffInYears === 1 ? 'year' : 'years'} ago`;
      } else if (diffInMonths > 0) {
        return `${diffInMonths} ${diffInMonths === 1 ? 'month' : 'months'} ago`;
      } else if (diffInWeeks > 0) {
        return `${diffInWeeks} ${diffInWeeks === 1 ? 'week' : 'weeks'} ago`;
      } else if (diffInDays > 0) {
        return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
      } else if (diffInHours > 0) {
        return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
      } else if (diffInMinutes > 0) {
        return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`;
      } else {
        return 'Just now';
      }
    },
    formatDateString(inputDateString) {
      const inputDate = new Date(inputDateString);
      const options = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      return inputDate.toLocaleString('en-US', options);
    }
  },
};

</script>
